module.exports = __webpack_public_path__ + "static/media/gallery-9.9f8e2d0e.jpeg";